const initializeVideoTransitionForUmbraco = () => {


    let configuration = null;

    const createConfiguration = () => {
        // create the video definitions for the transition manager.
        const videos = app.data.custom.find(o => o.type === "transitionVideos").data.videos.map(o => {
            return {
                id: o.videoId,
                src: `${config.MEDIA_DIRECTORY}${o.videoSrc.src}`,
                poster:`${config.MEDIA_DIRECTORY}${o.videoPoster.src}`
            }
        });

        const posterAssets = [];
        // create poster assets for the preloader.
        videos.forEach(v => {
            posterAssets.push({id: v.poster, url: v.poster})
        })


        // Preloade videos 

        videos.forEach(({src}) => {

            var v = document.createElement("video");
            v.muted = true;
            v.autoplay = false;
            v.style.width = 0;
            v.preload = "auto";
            v.src = src;
            document.body.appendChild(v);
       
            v.play();
            return v;
        })

        // Build the transition definition
        const transitions = app.data.custom.find(o => o.type === "transitions").data.transitionDefinitions.map(o => {
            /** @param route Object <{any?:string, to?:string, from?:string}>*/
            let route = {};
            o.trigger.forEach(t => {
                route[t.routeOrigin] = t.routeEquals;
            })
            /** @param video Object <{any?:string, in?:string, out?:string >*/
            let video = {}
            o.videos.forEach(v => {
                video[v.origin] = v.videoId
            })
            return {
                route,
                video
            }
        })

        const VideoTransitionConfig = {useImageCacheForPosterImages:true, videos, transitions}
        return {
            posterAssets, VideoTransitionConfig
        }
    }

    return {

        initialize (app) {
           
            configuration = createConfiguration(app);
            app.videoTransitionManager = new VideoTransitionManager(configuration.VideoTransitionConfig);

        },

        get posters () {
            return configuration.posterAssets
        },

        start (app, container) {
            app.videoTransitionManager.init(app, container);  
        }

    }

}